// Copy approved by Alphabet Greens. Facts marked "TODO" are hidden on the site until filled in (location, credit volume, registry).
import CookStove from "../assets/photos/cookstove-project.jpeg";
import Led from "../assets/photos/led-project.avif";
import Digester from "../assets/photos/food-digester-project.jpeg";
import Solar from "../assets/photos/solar-project.jpeg";
import Offset from "../assets/photos/Carbon-Offset.jpeg";
import Footprint from "../assets/photos/carbon-footprinting.jpeg";

export { CONTACT_EMAIL } from "../config.js";

export const projects = [
  {
    slug: "cookstove-project",
    title: "The CookStove Project",
    image: CookStove,
    category: "Community",
    status: "Registered",
    coords: null, // [lat, lng] to show a map
    sdgs: [1, 3, 5, 7, 13, 15],
    facts: [["Registry", "Gold Standard"], ["Programme", "PoA GS 12494, first VPA GS 12495"], ["Type", "Efficiency cookstoves"], ["Location", "India"], ["Credit volume", "TODO"]],
    tagline: "Clean cooking for households, less smoke and less wood.",
    intro:
      "Millions of households still cook on open fires. Our efficient cookstoves cut fuel use, reduce indoor smoke and avoid CO2 emissions that are verified and issued as carbon credits.",
    points: [
      ["Less fuel", "Efficient combustion means families burn far less wood or charcoal."],
      ["Healthier homes", "Reduced indoor smoke lowers respiratory risk, especially for women and children."],
      ["Verified credits", "Avoided emissions are validated and certified under Gold Standard."],
    ],
  },
  {
    slug: "led-project",
    title: "The LED Project",
    image: Led,
    category: "Community",
    status: "In development",
    coords: null,
    sdgs: [7, 11, 12, 13],
    facts: [["Registry", "Pending"], ["Type", "Energy efficiency"], ["Location", "TODO"], ["Credit volume", "TODO"]],
    tagline: "Efficient lighting that lowers bills and emissions.",
    intro:
      "We replace inefficient bulbs with LED lighting. The electricity saved reduces demand on the grid, and the resulting emission reductions are quantified and credited.",
    points: [
      ["Lower bills", "LEDs use a fraction of the power of incandescent bulbs."],
      ["Long life", "Fewer replacements means less waste."],
      ["Measured savings", "Energy savings are monitored and converted into credits."],
    ],
  },
  {
    slug: "food-digester-project",
    title: "The Food Digester Project",
    image: Digester,
    category: "Community",
    status: "In development",
    coords: null,
    sdgs: [7, 11, 12, 13],
    facts: [["Registry", "Pending"], ["Type", "Waste to energy"], ["Location", "TODO"], ["Credit volume", "TODO"]],
    tagline: "Turning food waste into clean energy.",
    intro:
      "Food digesters convert organic waste into biogas and fertiliser, preventing methane from landfills and giving communities a clean fuel source.",
    points: [
      ["Methane avoided", "Diverting waste from landfill prevents a potent greenhouse gas."],
      ["Clean fuel", "Biogas replaces firewood, LPG and kerosene."],
      ["Circular value", "Digestate returns to the soil as nutrient-rich fertiliser."],
    ],
  },
  {
    slug: "solar-project",
    title: "The Solar Project",
    image: Solar,
    category: "Renewable",
    status: "In development",
    coords: null,
    sdgs: [7, 8, 9, 13],
    facts: [["Registry", "Pending"], ["Type", "Solar"], ["Location", "TODO"], ["Credit volume", "TODO"]],
    tagline: "Renewable power for communities.",
    intro:
      "Our solar installations displace fossil-fuel electricity and diesel generation, delivering reliable power and verified emission reductions.",
    points: [
      ["Renewable power", "Clean generation replaces grid and diesel energy."],
      ["Energy access", "Reliable electricity for homes, schools and small businesses."],
      ["Credit generation", "Displaced emissions are certified and issued as credits."],
    ],
  },
];

export const services = [
  {
    slug: "carbon-offset",
    title: "Carbon Offset",
    image: Offset,
    tagline: "Neutralise the emissions you cannot yet eliminate.",
    intro:
      "We help organisations build an offset portfolio from high-integrity credits sourced from our own certified projects.",
    points: [
      ["Assess", "We size your residual emissions after reduction measures."],
      ["Match", "We select projects aligned with your goals and budget."],
      ["Retire", "Credits are retired on a public registry in your name."],
    ],
  },
  {
    slug: "carbon-footprinting",
    title: "Carbon Footprinting",
    image: Footprint,
    tagline: "You can't reduce what you haven't measured.",
    intro:
      "We calculate the carbon footprint of your company, product or event across scopes 1, 2 and 3, and show where reductions matter most.",
    points: [
      ["Measure", "Data collection and calculation following recognised standards."],
      ["Report", "Clear reports ready for stakeholders and disclosures."],
      ["Reduce", "A prioritised roadmap of reduction actions."],
    ],
  },
  {
    slug: "selling-credits",
    title: "Selling Credits",
    image: Offset,
    tagline: "Bring your project's credits to market.",
    intro:
      "Developers with certified projects can list credits with us and reach buyers looking for verified, high-quality offsets.",
    points: [
      ["Vetting", "We review your project documentation and certification."],
      ["Matching", "We connect your credits with qualified buyers."],
      ["Settlement", "Transparent pricing and registry transfer."],
    ],
  },
  {
    slug: "buying-credits",
    title: "Buying Credits",
    image: Offset,
    tagline: "Verified credits, transparent sourcing.",
    intro:
      "Buy credits certified by Gold Standard or VCS. Every credit corresponds to one tonne of CO2 and is retired on a public registry.",
    points: [
      ["Certified", "Validated by approved VVBs and certified by recognised standards."],
      ["Traceable", "Serial numbers and retirement records you can verify."],
      ["Flexible", "From single tonnes to long-term supply agreements."],
    ],
  },
];

export const faqs = [
  ["What is a carbon credit?", "One carbon credit represents one tonne of CO2 (or equivalent) avoided or removed, verified by an independent body and issued on a registry."],
  ["How do I know the credits are real?", "Our projects are validated by approved VVBs and certified under Gold Standard. Each credit has a unique serial number and is retired publicly."],
  ["What happens to the proceeds?", "Proceeds flow back into our carbon-offset projects so they can grow."],
  ["Can individuals buy credits?", "Yes. We work with businesses and individuals. Contact us for volumes and pricing."],
  ["How do I start with carbon footprinting?", "Get in touch and we will scope what data is needed for your company, product or event."],
  ["Can I list my own project's credits?", "If your project is certified, yes. See the Selling Credits page."],
];

export const legal = {
  privacy: ["Privacy Policy", "We collect only the information you give us, such as through our contact form, and use it to respond to you. We do not sell personal data. Contact us to access or delete your data."],
  terms: ["Terms of Service", "By using this website you agree to use it lawfully. Content is provided for information and does not constitute financial advice. Credit purchases are subject to separate agreements."],
  legal: ["Legal Notice", "Alphabet Greens Private Limited. CIN U94110MH2023PTC398387. Registered office: G-16, Apollo Industrial Estate, Off Mahakali Caves Road, Andheri (East), Chakala MIDC, Mumbai, Maharashtra 400093, India."],
  cookies: ["Cookies Policy", "This site uses only essential cookies and, where enabled, anonymous analytics. You can block cookies in your browser settings."],
};

export const steps = [
  ["Discover", "A 30-minute discovery call to understand your goals or your project."],
  ["Match", "We shortlist projects (buyers) or buyers (sellers) that fit."],
  ["Verify", "Documents, certification and additionality are reviewed."],
  ["Transact", "Agreement, pricing and registry transfer or retirement."],
  ["Report", "Retirement proof and impact reporting you can share."],
];

export const audiences = [
  {
    slug: "buyers",
    label: "Companies buying offsets",
    title: "For Buyers",
    cta: "Source verified credits",
    tagline: "High-integrity credits for net-zero and carbon-neutral claims.",
    intro: "We help companies measure what they emit, choose credits that stand up to scrutiny, and retire them on a public registry.",
    points: [
      ["Certified supply", "Credits from Gold Standard and other recognised registries."],
      ["Portfolio management", "Mix of project types, vintages and budgets handled for you."],
      ["Audit-ready", "Serial numbers and retirement records for every tonne."],
    ],
    faq: [
      ["What should I look for in a credit?", "Independent verification, additionality, no double counting, and a public retirement record."],
      ["Can I buy small volumes?", "Yes, contact us for minimums and pricing."],
      ["Do credits replace reductions?", "No. Offsetting covers residual emissions after you reduce."],
    ],
  },
  {
    slug: "sellers",
    label: "Project developers selling credits",
    title: "For Project Developers",
    cta: "Sell your supply",
    tagline: "Take certified credits to market with a partner that understands the registries.",
    intro: "Whether your project is registered or on its way, we help with documentation, verification and finding qualified buyers.",
    points: [
      ["Registration support", "Documentation, auditor selection and annual verification."],
      ["Buyer access", "Introductions to corporates looking for your project type."],
      ["Fair terms", "Transparent pricing and registry-based settlement."],
    ],
    faq: [
      ["Which standards do you work with?", "Gold Standard and other recognised registries. Ask us about yours."],
      ["Do I need to be certified first?", "Not always. Tell us your stage and we will advise."],
      ["What does it cost?", "Terms depend on volume and stage. Book a call for specifics."],
    ],
  },
  {
    slug: "investors",
    label: "Investors and partners",
    title: "For Investors & Partners",
    cta: "Partner with us",
    tagline: "Back community climate projects with measurable, verified returns.",
    intro: "Our projects generate certified credits and community benefits. Proceeds are reinvested so impact compounds.",
    points: [
      ["Verified impact", "Independent validation and public registry records."],
      ["Reinvestment model", "Credit proceeds fund project growth."],
      ["Community benefit", "Health, energy access and income at the household level."],
    ],
    faq: [
      ["How are projects governed?", "Through certification requirements, monitoring and annual verification."],
      ["How can we partner?", "Co-fund projects, offtake credits, or co-develop new ones. Book a call."],
    ],
  },
];
